import React from "react";
import { mailchimp_url } from "../../API/constants";
import "./Footer.css";
function Footer() {
  //
  // boom
  return (
    <div className="Footer">
      <div className="logo-footer">
        <img src="assets/logo.png" alt="" />
        <p>
          <strong>Claremont</strong> <br /> Main Road Mosque
        </p>
      </div>
      <div className="mainRow">
        <div className="mainColumn">
          <h2>Address</h2>
          <p>40 - 42 Main Road, Claremont, Cape Town, Western Cape, RSA</p>
          <br />
          <h2>Postal Address</h2>
          <p>P.O. Box 44572, Claremont, 7735</p>
          <br />
          <h2>Become a Member</h2>
          <p>Download the membership form</p>
        </div>
        <div className="mainColumn">
          <h2>Phone Numbers</h2>
          <p>Tel: +27 21 683 8384</p>
          <p>Fax: +27 21 683 8384</p>
          <br />
          <h2>Email Address</h2>
          <p>cmrm@iafrica.com</p>
          <p>Shariefa Wydeman</p>
        </div>
      </div>
      <div className="footerFoot">
        <h2>Join Our WhatsApp Broadcast List</h2>
        <p>
          WhatsApp{" "}
          <a href="https://wa.me/2792314273" target="_blank" rel="noreferrer">
            0792314273
          </a>{" "}
          with your name and surname to sign up
        </p>
        <h2>Subscribe to our weekly newsletter</h2>
        <div id="mc_embed_signup">
          <form
            action={mailchimp_url}
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            class="validate"
            target="_blank"
            novalidate
          >
            <div id="mc_embed_signup_scroll">
              <h2>Subscribe</h2>
              <div class="indicates-required">
                <span class="asterisk">*</span> indicates required
              </div>
              <div class="mc-field-group">
                <label for="mce-EMAIL">
                  Email Address <span class="asterisk">*</span>
                </label>
                <input
                  type="email"
                  name="EMAIL"
                  class="required email"
                  id="mce-EMAIL"
                  required
                />
                <span id="mce-EMAIL-HELPERTEXT" class="helper_text"></span>
              </div>
              <div id="mce-responses" class="clear foot">
                <div
                  class="response"
                  id="mce-error-response"
                  style={{ display: "none" }}
                ></div>
                <div
                  class="response"
                  id="mce-success-response"
                  style={{ display: "none" }}
                ></div>
              </div>
              <div
                style={{ position: "absolute", left: "-5000px" }}
                aria-hidden="true"
              >
                <input
                  type="text"
                  name="b_1cb86952863aedfa91505c97c_5011c2a698"
                  tabindex="-1"
                  value=""
                />
              </div>
              <div class="optionalParent">
                <div class="clear foot">
                  <input
                    type="submit"
                    value="Subscribe"
                    name="subscribe"
                    id="mc-embedded-subscribe"
                    class="button"
                  />
                  <p class="brandingLogo">
                    <a
                      href="http://eepurl.com/h-vQz1"
                      title="Mailchimp - email marketing made easy and fun"
                    >
                      <img
                        alt="logo"
                        src="https://eep.io/mc-cdn-images/template_images/branding_logo_text_dark_dtp.svg"
                      />
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </form>
        </div>
        <p>Privacy Policy | Copyright 2020 Claremont Main Road Mosque</p>
      </div>
    </div>
  );
}
export default Footer;
